/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [  
  {
    path: '/totem',
    // Relative to /src/views
    name: 'path.dashboard.title',
    meta: { layout: 'public' },
    view: 'public/totem/Index'
  },
  {
    path: '/totem-horizontal',
    // Relative to /src/views
    name: 'path.dashboard.title',
    meta: { layout: 'public' },
    view: 'public/totem/IndexHorizontal'
  },
  {
    path: '/change-pass/:token',
    // Relative to /src/views
    name: 'path.dashboard.title',
    meta: { layout: 'public' },
    view: 'public/ChangePass'
  },
  {
    path: '/',
    // Relative to /src/views
    meta: { layout: 'public' },
    view: 'public/Home'
  },
  {
    path: '/share',
    // Relative to /src/views
    meta: { layout: 'public' },
    view: 'public/share/Index'
  },
  {
    path: '/point/',
    // Relative to /src/views
    meta: { layout: 'public' },
    view: 'public/Home'
  },
  {
    path: '/point/:pointID',
    // Relative to /src/views
    meta: { layout: 'public' },
    view: 'public/Home'
  },
  {
    path: '/test',
    // Relative to /src/views
    meta: { layout: 'public' },
    view: 'public/Test'
  },
  {
    path: '/external/activities',
    // Relative to /src/views
    meta: { layout: 'public' },
    view: 'external/activities/Index'
  },
  {
    path: '/checkout/:pointID/',
    // Relative to /src/views
    meta: { layout: 'public' },
    view: 'public/Home'
  },
  {
    path: '/order/:orderID/:status',
    // Relative to /src/views
    meta: { layout: 'public' },
    view: 'public/Home'
  },
  {
    path: '/external/activities',
    // Relative to /src/views
    meta: { layout: 'public' },
    view: 'external/activities/Index'
  },
  {
    path: '/external/aena/:id/:locale',
    // Relative to /src/views
    meta: { layout: 'public' },
    view: 'external/aena/Index'
  },
  {
    path: '*',
    // Relative to /src/views
    meta: { layout: 'public' },
    view: '404'
  }
]
